module.exports = __webpack_public_path__ + "static/media/GothamLight.f76e3adf.otf";